import TagSolidSVG from "@design-system/ui-icons/vanilla/TagSolid"
import { createIcon } from "../createIcon"

export const TagSolidIcon = createIcon(TagSolidSVG)
